// Map payment currency -> flagcdn country/region code (lowercase)
const CURRENCY_FLAG = {
  USD: 'us',
  EUR: 'eu',
  INR: 'in',
  GBP: 'gb',
  AED: 'ae',
  SAR: 'sa',
  QAR: 'qa',
  KWD: 'kw',
  BHD: 'bh',
  OMR: 'om',
  EGP: 'eg',
  JOD: 'jo',
  LBP: 'lb',
  IQD: 'iq',
  MAD: 'ma',
  TND: 'tn',
  TRY: 'tr',
  CNY: 'cn',
  JPY: 'jp',
  KRW: 'kr',
  THB: 'th',
  VND: 'vn',
  IDR: 'id',
  MYR: 'my',
  SGD: 'sg',
  AUD: 'au',
  NZD: 'nz',
  CAD: 'ca',
  CHF: 'ch',
  BRL: 'br',
  ARS: 'ar',
  CLP: 'cl',
  COP: 'co',
  MXN: 'mx',
  BOB: 'bo',
  DKK: 'dk',
  NOK: 'no',
  SEK: 'se',
  PLN: 'pl',
  CZK: 'cz',
  HUF: 'hu',
  RON: 'ro',
  RUB: 'ru',
  UAH: 'ua',
  ZAR: 'za',
  NGN: 'ng',
  PKR: 'pk',
  BDT: 'bd',
  LKR: 'lk',
  PHP: 'ph',
  ILS: 'il'
};

export const currencyFlagUrl = (code) => {
  if (!code) return null;
  const cc = CURRENCY_FLAG[code.toUpperCase()];
  if (!cc) return null;
  return `https://flagcdn.com/w40/${cc.toLowerCase()}.png`;
};
